
export const environments = {

  production: true,

  version: "0.1.0",

};
